/* src/app/pages/tasks/components/reminders/task-reminder-form/task-reminder-form.component.scss */
.container__tab-form {
  display: flex;
  flex-direction: column;
  margin: 0 0 15px;
  padding: 10px 20px 20px;
  border-radius: 10px;
  background-color: #ffffff;
}
.container__form-row {
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  margin-bottom: 20px;
  min-height: 50px;
}
.container__input {
  flex: 1;
  margin-inline-end: 20px;
  outline: none;
}
.container__input--last-in-row {
  margin-inline-end: 0;
}
.container__inputs-wrapper {
  display: flex;
  flex-direction: row;
  flex: 1;
}
.container__textarea {
  margin-top: 20px;
  margin-bottom: 0;
}
.container__tab-buttons-wrapper {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}
.container__tab-button {
  margin-inline-start: 10px;
}
/*# sourceMappingURL=task-reminder-form.component.css.map */
